import React from 'react';
import AreaButtonGridPart from '../components/areaButtonGridPart/areaButtonGridPart';
import { IGridPartInternalProps } from '../interface';
import * as S from './styles';


function CardGridPart(props: IGridPartInternalProps) {
  const {
    part,
    isCollumnGrid,
  } = props;

  return (
    <S.ContainerCardShopping $show={isCollumnGrid}>
      <S.BodyCardShopping>
        <S.AreaTitleCardShopping>
          <S.TitleCardShopping title={part.partName}>
            {part.partName}
          </S.TitleCardShopping>
        </S.AreaTitleCardShopping>
        <S.TextCardShopping
          title={`${part.partCategoryName} > ${part.partSubCategoryName}`}>
          {`${part.partCategoryName} > ${part.partSubCategoryName}`}
        </S.TextCardShopping>
      </S.BodyCardShopping>

      <AreaButtonGridPart {...props} />
    </S.ContainerCardShopping>
  )
}

export default CardGridPart